<template>
    <div v-if="data">
        <div @click="$emit('handleCloseQuickView')" class="overlay" :class="{'show':openQuickSettingView}"></div>
        <div class="bottom-sheet quick-view-container" :class="{'show':openQuickSettingView }">
            <div class="quick-view" v-if="selectedMetal" >
                <div class="steps_close">
                    <SvgHeaderSvg class="largesvg" @click="$emit('handleCloseQuickView')" :type="'close'" />
                </div>
              
                <div class="quick-view-content">
                    <div class="images-container">
                        <CyoSettingQuickViewImageSlider v-if="images" :images="images"/>
                    </div>
                    
                    <h4 class="title font-active">{{selectedMetal.product_name}}</h4>
                    
                    <h5 class="text-center price d-flex align-items-center justify-content-center">
                            <span>{{ $formatPrice(selectedMetal.price) }}</span>
                            <span v-if="!$country.is_india && selectedMetal.discount_label" class="ms-2 discounted-price">{{ $formatPrice(selectedMetal.mrp) }}</span>
                            <span v-if="!$country.is_india && selectedMetal.discount_label" class="ms-2 disc_chip_pdp ">{{ selectedMetal.discount_label }}% OFF</span>
                    </h5>
                  
                    <div class="metals-box">
                        <CyoSettingQuickViewMetalDropdown
                            :metals="data.metals"
                            :selectedMetal="selectedMetal"
                            @toggleOption="updateMetal"
                        />
                    </div>
                    <div class="d-flex gap-3 btn-container">
                        <button class="cta_btn details-btn" @click="openDetailsPage(selectedMetal.slug)">DETAILS</button>
                        <button v-if="!showLoader" class="cta_btn setting-btn " @click="chooseSetting()">
                            CHOOSE THIS SETTING 
                        </button>
                        <button v-else class="cta_btn setting-btn">
                            PLEASE WAIT...
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { cyoStore }  from '@/stores/cyo/cyo';
    import { cyodetailStore } from '@/stores/cyodetail/cyodetail';

    const {$formatPrice, $selectsettingGtag, $country} = useNuxtApp()
    const localePath = useLocalePath()
    const route = useRoute()
    const router = useRouter()

    const emits = defineEmits(['handleCloseQuickView'])
    
    const props = defineProps(['data','openQuickSettingView'])

    const {data,openQuickSettingView} = toRefs(props)

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType

    const storeCyo = cyoStore();
    const store = cyodetailStore();

    const showLoader = ref(false)

    const selectedMetal  = computed(()=>{
      
        if(!data.value.metals?.length){
            return 
        }

        return data.value.metals.find(metal => metal.selected === 1)
      
    })

    function updateMetal(metal) {
       
       data.value.metals.filter((item) =>{
           if(item.metal === metal){
               item.selected = 1
           }else{
               item.selected = 0
           }
       }) 
   }

    const images = computed(()=>{
        const displayImages = ['front','left','video','side','model']
        const imagesObj = {};
        const metalImgs = selectedMetal.value.images

        if(selectedMetal.value){
            Object.keys(metalImgs).map((key)=>{
                if(displayImages.includes(key)){
                    
                    imagesObj[key] = metalImgs[key]
                }                
            } 
        )

            return imagesObj

        }
    })


    const selectedShape = computed(() => {
        return storeCyo.getShape( moduleSubType)
    })

    function chooseSetting(type){
        selectSetting()
        emits('handleCloseQuickView')
    }

    async function selectSetting(){
        showLoader.value = true

        const settings = { moduleType: moduleType, moduleSubType: moduleSubType, route: route, slug: selectedMetal.value.slug }

        await store.setSettingForDetailPage(settings)

        await storeCyo.setSetting({ moduleSubType: moduleSubType })

        $selectsettingGtag(moduleSubType);

        const diamond = storeCyo.getDiamond(moduleSubType)

        if (diamond) {
            return router.push( localePath( {name: 'cyo-complete-'+moduleSubType, query:{ sid: selectedMetal.value.id, did: diamond.id }} )); 
        }

        // // if shape is selected
        else if (selectedShape.value) {
            
            return router.push( localePath( {name: 'cyo-diamond-list-'+moduleSubType, query:{Shape: selectedShape.value.charAt(0).toUpperCase() + selectedShape.value.slice(1) }} )); 
        }
        else{
            router.push(localePath({name: 'cyo-diamond-list-'+moduleSubType})); 
        }
        showLoader.value = false
    }

    const openDetailsPage = (slug)=>{
        emits('handleCloseQuickView')
        nextTick(()=>{
                setTimeout(()=>{
                router.push(localePath(currentPath(slug)))   
            },500)
        })
    }



    function currentPath(slug){

        let payload = {}

        if (moduleSubType === 'ring') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if (moduleSubType === 'pendant') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if (moduleSubType === 'earring') {
            payload =  { name:'cyo-setting-detail-'+moduleSubType, params:{ slug: slug } }
        }

        if(moduleSubType === 'band'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'womens-wedding-rings' } }
        }

        if(moduleSubType === 'couple-bands'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'couple-rings' } }
        }

        if(moduleSubType === 'shop-all-ring'){
            payload =  { name: 'shop-detail', params:{ slug: slug, type: 'wedding-band' } }
        }

        if ( moduleType === 'cyo' ) {

            let shape = route?.query?.Shape ? route?.query?.Shape :  'Round'

            if( import.meta.client ){

                let urlparam = new URLSearchParams(window.location.search);
                
                shape = urlparam.has("Shape") ? urlparam.get("Shape") : 'Round' ;
            }
            payload = { ...payload, ...{ query: { Shape : shape }  }}
        }
        return payload
    }

    onBeforeUnmount(()=>{
        emits('handleCloseQuickView')
    })
</script>

<style scoped>

.overlay{
    position: fixed;
    /* top: 0; */
    left: 0;
    bottom: -100%;
    height: 0;
    width: 100%;
    background: #00000063;
    z-index: 99;
    pointer-events: auto;
    transition: .1s;
}

.overlay.show{
    bottom: 0;
    height: 100%;
    transition-delay: 0.1s;
}

.bottom-sheet{
    position: fixed;
    bottom: -200px;
    left: 0;
    height: 0;
    width: 100%;
    background-color: #fff;
    transition: 1s;
    z-index: 100;
}

.bottom-sheet.show{
    height: 580px;
    max-height: 90vh;
    bottom: 0;
    transition: 0.6s;
}


.quick-view-container {
    padding: 12px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    width: 100%;
    overflow: auto;
}

.images-container{
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

h4.title {
    font-size: 18px;
    color: #212529;
    text-align: center
}

h5.price {
    font-size: 18px;
    color: var(--green);
    font-weight: 600;
    margin-top: 16px;
}

.price .discounted-price{
    color: #656565;
    text-decoration: line-through;
    /* margin-left: 0; */
    /* margin-top: 5px; */
    display: block;
    font-size: 16px;
    font-weight: 400;
}

.metals-box{
    margin: 25px auto;
}

.btn-container{
    max-width: 360px;
    margin:auto;
}

.cta_btn {
    border: 1px solid var(--green);
    text-align: center;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1.12px;
    padding: 12px 16px;
    /* min-width: 100px; */
}

.cta_btn.details-btn{
    color: var(--green);
    background-color: #fff;
    min-width: 110px;
}

.cta_btn.setting-btn{
    color: #fff;
    background-color: var(--green);
    width: 100%;
}

.steps_close {
    text-align: right;
    margin-bottom: 5px;

}

.largesvg {
    transform: scale(1.3);
}
</style>